import { type Route } from '#app/routes/mocra+/_sections+/+types/612.ts'
import { SECTIONS } from '#app/routes/mocra+/_sections+/section-data.ts'
import { SectionDetail } from '#app/routes/mocra+/_sections+/section-detail.tsx'

export const meta: Route.MetaFunction = () => [
	{ title: 'MoCRA — §612 Fragrance Allergen Transparency' },
]

export default function Section612() {
	return <SectionDetail section={SECTIONS['612']} />
}
